import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'

import { invoke } from '../integration'

export const getApplication = createAsyncThunk('application/get-application', async (id) => {
    const res = await invoke(`getApplication?id=${id}`, 'GET', null)
    return res.body
})

export const createApplication = createAsyncThunk('application/create-application', async (payload) => {
    const res = await invoke(`createApplication`, 'POST', payload)
    return res.body
})

export const API_IDLE = 'API_IDLE'
export const API_PENDING = 'API_PENDING'
export const API_SUCCESS_CREATE_APPLICATION = 'API_SUCCESS_CREATE_APPLICATION'
export const API_SUCCESS_GET_APPLICATION = 'API_SUCCESS_GET_APPLICATION'
export const API_ERROR = 'API_ERROR'

export const appData = createSlice({
    name: 'appData',
    initialState: {
        appAPICallingStatus: API_IDLE,
        applications: []
    },
    reducers: {

    },
    extraReducers(builder) {
        builder
            .addCase(getApplication.pending, (state) => {
                state.appAPICallingStatus = API_PENDING
            })
            .addCase(getApplication.fulfilled, (state, action) => {
                state.appAPICallingStatus = API_SUCCESS_GET_APPLICATION
                if (action.payload.length > 0) {
                    state.applications.push(action.payload[0])
                }
            })
            .addCase(getApplication.rejected, (state, action) => {
                state.appAPICallingStatus = API_ERROR
            })
            .addCase(createApplication.pending, (state) => {
                state.appAPICallingStatus = API_PENDING
            })
            .addCase(createApplication.fulfilled, (state, action) => {
                state.appAPICallingStatus = API_SUCCESS_CREATE_APPLICATION
                state.applications.push(action.payload)
            })
            .addCase(createApplication.rejected, (state, action) => {
                state.appAPICallingStatus = API_ERROR
            })
    }
})

export default appData.reducer